var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialShareChain = function SvgSocialShareChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.675 5.185a4 4 0 0 1 .856-.646c1.717-.943 3.916-.439 5.016 1.228L8.21 7.095A2.006 2.006 0 0 0 5.933 5.94a1.9 1.9 0 0 0-.969.534L2.41 9.029a1.984 1.984 0 0 0 0 2.811 1.994 1.994 0 0 0 2.817 0l.79-.788c.72.284 1.486.397 2.247.344l-1.741 1.737a3.826 3.826 0 0 1-5.403 0 3.807 3.807 0 0 1 0-5.391zm4.06-4.057L5.992 2.866c.76-.059 1.527.06 2.246.338l.79-.788a1.994 1.994 0 0 1 2.818 0 1.984 1.984 0 0 1 0 2.811L9.286 7.783a2 2 0 0 1-2.818 0 2.2 2.2 0 0 1-.434-.622L4.697 8.489c.143.214.285.398.476.581.48.48 1.1.843 1.806 1.009a3.81 3.81 0 0 0 3.596-1.014l2.556-2.557a3.807 3.807 0 0 0 0-5.391 3.826 3.826 0 0 0-5.403 0z"
  })));
};
export default SvgSocialShareChain;